/**
 * Evetro colors (fine farga)
 * Numbers in property names, such as evetro_green80,
 * refers to the opacity of the color relative to the color black.
 */
export default Object.freeze({
  // Status colors
  disabled: '#b3bcbc',
  error: '#ff4136',
  info: '#7fdbff',
  success: '#01ff70',
  warning: '#ffa963',
  required: '#f27474',

  // Evetro green palette
  evetro_green10: '#ccfff9',
  evetro_green45: '#00e6cb',
  evetro_green: '#34bfb7',
  evetro_green65: '#00b39e',
  evetro_green70: '#009987',
  evetro_green75: '#008071',
  evetro_green80: '#00665a',
  evetro_green_opaque60: 'rgba(0, 198, 174, 0.5)',
  evetro_green_disabled: '#93e2cb',

  // Evetro dark palette
  evetro_dark: '#363a44',
  evetro_dark_light: '#4a4d56',
  evetro_bg_gray: '#f3f4f9',
  evetro_bg_gray10: '#e6e8f2',
  evetro_gold: '#b18e32',
  evetro_gold_light: '#d3a93e',

  // Blue palette
  navy: '#001f3f',
  dark_blue10: '#404956',
  dark_blue30: '#394e60',
  dark_blue35: '#435b70',
  dark_blue: '#4d6980',
  dark_blue50: '#60839f',
  dark_blue60_opaque: 'rgba(77, 105, 128, 0.5)',
  blue_day_background_selected: '#4a90e2',
  blue: '#0074d9',
  hover_blue: '#1ccaff',
  light_blue: '#99ccff',
  light_blue_opaque: 'rgba(153, 204, 255, 0.1)',
  purple: 'rgba(33, 35, 41, 0.26)',

  // Red pallette
  red90: '#fbd0d0',
  red75: '#f48b8b',
  red: '#f27474',
  red65: '#f05c5c',
  red60: '#ee4444',
  red50: '#e91616',
  red40: '#bb1111',
  evetro_red: '#c35f7c',

  // Black to white palette
  black: '#222222',
  gray90: '#2d2d2d',
  gray80: '#333333',
  gray70: '#4d4d4d',
  gray60: '#666666',
  gray50: '#7f7f7f',
  gray40: '#999999',
  gray30: '#b3b3b3',
  gray20: '#cccccc' /* Button background */,
  gray12: '#e0e0e0',
  gray10: '#e6e6e6',
  gray7: '#ededed',
  gray3: '#f7f7f7',
  white: '#ffffff',

  // Calendar palette
  day_border: '#c4c4c4',
  day_text_today: '#ff4136',
  day_text_sunday: '#dce0e0',
  day_text_weekday: '#a7b6b6',
  day_text_weeknumber: '#8b9898',
  day_background_selected: '#00c6ae',
  day_text_selected: '#7a7a7a',
  day_text_range_selected: '#ffffff',
  day_background_range_selected: '#c8fff3',
  day_background_sunday: '#f7f8f8',
  day_text_disabled: '#b3bcbc',
  day_background_disabled: '#eff1f1',
  day_text_outside: '#dce0e0',
  day_background_outside: '#eff1f1',
  button_text_today: '#99ccff',

  userColors: [
    '#ed5565',
    '#a0d468',
    '#ffce54',
    '#5d9cec',
    '#f58231',
    '#ac92ec',
    '#6ebbf0',
    '#ec87c0',
    '#b8d261',
    '#469990',
    '#aaffc3',
    '#d770ad',
    '#c35f7c',
    '#fffac8',
    '#b6eeac',
    '#a9a021',
    '#e0b685',
    '#61637b'
  ],

  metricsColors: [
    '#001949',
    '#5567C9',
    '#8d9ac5',
    '#ffc2b8',
    '#E17a8d',
    '#002a5e',
    '#5861a1',
    '#ec87c0',
    '#6ebbf0',
    '#ac92ec',
    '#5d9cec'
  ]
});
